import { AnalyticService } from '../../apis/analytics';
import { FETCH_TOTAL_SALES_END } from '../mutations.type';
import * as moment from 'moment';

import { FETCH_TOTAL_SALES } from '../actions.type';
const initialState = {
  chartData: {
    datasets: [
      {
        data: [],
      },
    ],
  },
  options: {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            stepSize: 50,
            callback: function(value, index, values) {
              const currencySign = localStorage.getItem('currencySign') || '$';
              return currencySign + value;
            },
          },
        },
      ],
      xAxes: [
        {
          type: 'time',
          time: {
            displayFormats: {
              hour: 'hA',
            },
          },
          ticks: {
            maxTicksLimit: 4,
            maxRotation: 0,
            padding: 10,
            fontSize: 12,
          },
          gridLines: { display: false },
        },
      ],
    },
    legend: {
      display: false,
    },
    responsive: true,
    maintainAspectRatio: false,
  },
  totalSales: 0,
  uselTotalSales: 0,
  onlineStoreSales: 0,
};

export const state = { ...initialState };

export const actions = {
  async [FETCH_TOTAL_SALES](context, args) {
    let strStores = Array.isArray(args.stores) ? args?.stores.join(',') : args.stores;
    const { data } = await AnalyticService.fetchTotalSales(args.fromTime, args.toTime, strStores, args?.timezone);
    let maxValue = Math.max(...data.details.dataset);
    let stepSize = maxValue === 0 ? 20 : maxValue > 20 ? Math.round(maxValue / 4) : maxValue;
    initialState.options.scales.yAxes[0].ticks.stepSize = stepSize;
    let dataset = {
      type: 'line',
      data: data.details.dataset,
      borderColor: '#058b45',
      backgroundColor: '#eefff5',
      pointBackgroundColor: '#058b45',
      fill: true,
      pointRadius: 1,
      pointHitRadius: 1,
    };
    let rs = {
      chartData: { datasets: [dataset], labels: data.details.labels },
      options: { ...initialState.options },
      totalSales: Math.round(data?.total_sales * 100) / 100 || 0,
      uselTotalSales: Math.round(data?.upsell_sales * 100) / 100 || 0,
      onlineStoreSales: Math.round(data?.online_store_sales * 100) / 100 || 0,
    };
    context.commit(FETCH_TOTAL_SALES_END, rs);
    return rs;
  },
};

/* eslint no-param-reassign: ['error', { 'props': false }] */
export const mutations = {
  [FETCH_TOTAL_SALES_END](state, data) {
    // console.log(data);
    state.chartData = data.chartData;
    state.options = data.options;
    state.totalSales = data.totalSales;
    state.uselTotalSales = data.uselTotalSales;
    state.onlineStoreSales = data.onlineStoreSales;
  },
};

const getters = {
  totalSalesReport(state) {
    return state.chartData;
  },
  chartSalesOpts(state) {
    return state.options;
  },
  totalSales(state) {
    return state.totalSales;
  },
  uselTotalSales(state) {
    return state.uselTotalSales;
  },
  onlineStoreSales(state) {
    return state.onlineStoreSales;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
